module.exports = __webpack_public_path__ + "img/circle-div.46d197d1.svg";